import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastProvider = () => {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{ zIndex: 9999 }}
        toastClassName="custom-toast-container"
        bodyClassName="custom-toast-body"
        icon={false}
        closeButton={false}
        containerId="main-toast-container"
      />

      {/* Global toast styles */}
      <style>
        {`
          /* Base toast styling */
          .Toastify__toast {
            padding: 0 !important;
            overflow: visible !important;
            margin-bottom: 16px !important;
            background: transparent !important;
            box-shadow: none !important;
            border-radius: 10px !important;
          }
          
          /* Hover effect for toasts */
          .Toastify__toast:hover {
            transform: translateY(-2px);
            transition: transform 0.2s ease;
          }
          
          /* Remove padding from body */
          .Toastify__toast-body {
            padding: 0 !important;
            margin: 0 !important;
          }
          
          /* Progress bar styling */
          .Toastify__progress-bar {
            height: 3px !important;
            opacity: 0.7 !important;
          }
          
          .Toastify__progress-bar--success {
            background: #4CAF50 !important;
          }
          
          .Toastify__progress-bar--error {
            background: #F44336 !important;
          }
          
          .Toastify__progress-bar--warning {
            background: #FF9800 !important;
          }
          
          .Toastify__progress-bar--info {
            background: #2196F3 !important;
          }
          
          /* Responsive container */
          .Toastify__toast-container {
            width: 360px !important;
            max-width: 90vw !important;
            padding: 0 !important;
            z-index: 9999 !important;
          }
          
          /* Mobile styles */
          @media (max-width: 480px) {
            .Toastify__toast-container {
              width: 100% !important;
              left: 0 !important;
              margin: 0 !important;
              top: 0 !important;
              padding: 8px !important;
              border-radius: 0 !important;
            }
            
            .Toastify__toast {
              margin-bottom: 8px !important;
              border-radius: 8px !important;
            }
            
            /* Adjust mobile positioning */
            .Toastify__toast-container--top-right {
              top: 0 !important;
              right: 0 !important;
            }
          }
        `}
      </style>
    </>
  );
};

export default ToastProvider; 